const FEEDBACK_DRAFT_PREFIX = 'feedback-draft-';

export function getFeedbackDraftKey(messageId: string): string {
  return `${FEEDBACK_DRAFT_PREFIX}${messageId}`;
}

export function getFeedbackDraft(messageId: string): string {
  if (!messageId || typeof sessionStorage === 'undefined') return '';
  try {
    return sessionStorage.getItem(getFeedbackDraftKey(messageId)) ?? '';
  } catch {
    return '';
  }
}

export function saveFeedbackDraft(messageId: string, text: string): void {
  if (!messageId || !text.trim() || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(getFeedbackDraftKey(messageId), text);
  } catch {
    // ignore quota / privacy errors
  }
}

export function clearFeedbackDraft(messageId: string): void {
  if (!messageId || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(getFeedbackDraftKey(messageId));
  } catch {
    // ignore
  }
}
